<template>
  <div>
    <div :class="['mv-image-box-container', { disabled: checkin.aasmState !== 'pending', dragstart: onDragItem }]"
      @dragover.prevent
      @dragenter.prevent
      @drop="cancelDrop">
      <template v-if="images">
        <div v-for="(image, index) in images" :key="index"
          class="mv-image-box"
          draggable
          @dragstart="onDragstart($event, image)"
          @dragover.prevent.stop="onDragover($event, image)"
          @drop="onDrop($event, image, 0)">
          <img :src="image.url">
          <button type="button" @click="removeImage(index)" />
          <div class="drop-catch-field left" @dragover="showPosition($event)" @drop.prevent.stop="onDrop($event, image, 0)" />
          <div class="drop-catch-field right" @dragover="showPosition($event)" @drop.prevent.stop="onDrop($event, image, 1)" />
        </div>
      </template>

      <div v-if="images.length < MAX_FILES" class="mv-image-btn">
        <input type="file" ref="file" multiple
          :disabled="checkin.aasmState !== 'pending'"
          @change="onFileChange">
        <div class="mv-image-btn-label">
          <i class="fal fa-plus-circle mb-1" />
          Add media
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const MAX_FILES = 10

export default {
  name: 'MomentMedia',
  props: {
    checkin: { type: Object, required: true }
  },
  data() {
    return {
      images: this.checkin.images,
      onDragItem: null
    }
  },
  created() {
    this.MAX_FILES = MAX_FILES
  },
  methods: {
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        return
      }

      this.createImage(Array.from(files).slice(0, MAX_FILES - this.images.length))
    },
    createImage(files) {
      const vm = this
      for (let index = 0; index < files.length; index++) {
        const reader = new FileReader()
        reader.onload = (event) => {
          const imageUrl = event.target.result
          vm.images.push({ url: imageUrl })
          this.$emit('setImages', this.images)
        }
        reader.readAsDataURL(files[index])
      }
    },
    removeImage(index) {
      this.images.splice(index, 1)
      this.$emit('setImages', this.images)
    },
    onDragstart(evt, onDragItem) {
      evt.currentTarget.classList.add('dragstart')
      this.onDragItem = onDragItem
    },
    onDrop(evt, onDropedItem, shift) {
      evt.currentTarget.parentElement.classList.remove('dragover')
      document.querySelectorAll('.mv-image-box').forEach((item) => item.classList.remove('dragstart'))

      if (this.onDragItem !== onDropedItem) {
        this.images.splice(this.images.findIndex((img) => img === this.onDragItem), 1)
        if (onDropedItem === null) {
          this.images.push(this.onDragItem)
        } else {
          this.images.splice(this.images.findIndex((img) => img === onDropedItem) + shift, 0, this.onDragItem)
        }
      }

      this.onDragItem = null
      this.$emit('setImages', this.images)
    },
    onDragover(evt, image) {
      document.querySelectorAll('.mv-image-box').forEach((item) => item.classList.remove('dragover'))
      if (this.onDragItem !== image) {
        evt.currentTarget.classList.add('dragover')
      }
    },
    showPosition(evt) {
      document.querySelectorAll('.drop-catch-field').forEach((item) => item.classList.remove('dragging'))
      evt.currentTarget.classList.add('dragging')
    },
    cancelDrop() {
      document.querySelectorAll('.mv-image-box').forEach((item) => item.classList.remove('dragstart'))
      document.querySelectorAll('.mv-image-box').forEach((item) => item.classList.remove('dragover'))
      document.querySelectorAll('.drop-catch-field').forEach((item) => item.classList.remove('dragging'))

      this.onDragItem = null
    }
  }
}
</script>
